import { Icon, Icons } from '@silverfort/sf-components';
import { FC } from 'react';
import { LogsFilters } from '../../types';
import { FilterConfig } from './types';

interface FilterDropdownProps {
    filterType: 'sources' | 'destinations';
    filterConfig: FilterConfig;
    filters: LogsFilters;
    onFilterClick: (filterConfig: FilterConfig) => void;
    onRemoveFilter: () => void;
}

const FilterDropdown: FC<FilterDropdownProps> = ({
    filterType,
    filterConfig,
    filters,
    onFilterClick,
    onRemoveFilter
}) => {
    const getSelectedItemsCount = (): number => {
        if (filterType === 'sources') {
            return (
                (filters.includeSources?.length || 0) +
                (filters.includeSourcesIps?.length || 0) +
                (filters.includeSourceIpOrName?.length || 0)
            );
        }
        return (
            (filters.includeDestinations?.length || 0) +
            (filters.includeDestinationsIps?.length || 0) +
            (filters.includeDestinationsIpOrName?.length || 0) +
            (filters.includeDestinationsApplications?.length || 0)
        );
    };

    const getFilterDisplayText = (): string => {
        const totalCount = getSelectedItemsCount();

        if (totalCount === 0) return 'All';
        if (totalCount === 1) return '1 value';
        return `${totalCount} values`;
    };

    const hasSelectedItems = getSelectedItemsCount() > 0;

    return (
        <div
            className={`flex h-8 max-w-[260px] select-none bg-sf-white items-center truncate rounded-lg border px-3 font-sf-primary text-13 transition duration-300 ease-out ${
                hasSelectedItems
                    ? '[&]:bg-sf-primary-100 border-sf-primary-100 hover:border-sf-primary-200 active:border-sf-primary-500'
                    : 'bg-sf-white border-sf-gray-100 hover:border-sf-gray-400 active:border-sf-gray-800'
            }`}>
            <button onClick={() => onFilterClick(filterConfig)}>
                <span className="p-0.5 font-normal">{`${filterConfig.label}${hasSelectedItems ? ':' : ''}`}</span>
                <span className="mx-1 font-medium">{getFilterDisplayText()}</span>
            </button>
            {hasSelectedItems && (
                <button
                    className="w-fit px-0.5"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemoveFilter();
                    }}>
                    <Icon icon={Icons.Cancel} />
                </button>
            )}
        </div>
    );
};

export default FilterDropdown;
